import React, { Dispatch } from "react";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
  Button,
  ButtonDropdown
} from "reactstrap";
import { connect } from "react-redux";
import { Application } from "../../../../App/Models/Application";
import { IAppState, LoadingDisplay, ApiRequest, appPaths, LoadingState } from "../../../../Common";

type Props = {
  value?: Application;
  onSelected: (app: Application) => void;
};

type State = {
  isOpen: boolean;
};

type StateProps = {
  applications: Application[];
  appLoadingState: LoadingState;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  applications: state.app.applications,
  appLoadingState: state.app.appsLoadingState
});

class FeedbackAppDropdown extends React.Component<Props & StateProps, State> {
  constructor(props: Props & StateProps) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  onToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render() {
    const styles: React.CSSProperties = {
      backgroundColor: "white",
      color: "black",
      opacity: "initial"
    };

    return (
      <ButtonGroup>
        <Button disabled style={styles}>
          Application
        </Button>
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.onToggle}>
          {this.props.appLoadingState.isLoading ? (
            <LoadingDisplay />
          ) : (
            <>
              <DropdownToggle caret>
                {this.props.value ? this.props.value.name : "Select an app"}
              </DropdownToggle>
              <DropdownMenu>
                {this.props.applications.map(app => (
                  <DropdownItem key={app.authId} onClick={() => this.props.onSelected(app)}>
                    {app.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </>
          )}
        </ButtonDropdown>
      </ButtonGroup>
    );
  }
}

export default connect(mapStateToProps)(FeedbackAppDropdown);
